import React from "react";
import { TextField, MenuItem, Typography, Box } from "@mui/material";
import { useFormikContext } from "formik";
import { fieldConfig } from "../config/fieldConfig";

const currencies = ["USD", "NGN", "EUR"];

const PricingSection = () => {
  const { values, handleChange, errors, touched } = useFormikContext();

  return (
    <Box display="flex" flexDirection="column" gap={2}>
      <Typography variant="h6" gutterBottom>
        Pricing
      </Typography>

      <Typography variant="body2" color="textSecondary" gutterBottom>
        Provide the pricing details for your tour below. This includes the price
        per person, currency, and optional discount information. Be sure to
        specify the minimum group size required for any discounts.
      </Typography>

      <TextField
        fullWidth
        label={fieldConfig.pricing.pricePerPerson.label}
        placeholder={fieldConfig.pricing.pricePerPerson.placeholder}
        name="pricing.pricePerPerson"
        type="number"
        value={values.pricing.pricePerPerson}
        onChange={handleChange}
        error={touched?.pricing?.pricePerPerson && Boolean(errors?.pricing?.pricePerPerson)}
        helperText={
          touched?.pricing?.pricePerPerson && errors?.pricing?.pricePerPerson
            ? errors.pricing.pricePerPerson
            : fieldConfig.pricing.pricePerPerson.helperText
        }
      />

      <TextField
        fullWidth
        select
        label={fieldConfig.pricing.currency.label}
        name="pricing.currency"
        value={values.pricing.currency}
        onChange={handleChange}
        error={touched?.pricing?.currency && Boolean(errors?.pricing?.currency)}
        helperText={
          touched?.pricing?.currency && errors?.pricing?.currency
            ? errors.pricing.currency
            : fieldConfig.pricing.currency.helperText
        }
      >
        {currencies.map((cur) => (
          <MenuItem key={cur} value={cur}>
            {cur}
          </MenuItem>
        ))}
      </TextField>

      <Typography variant="subtitle1">Discount (Optional)</Typography>

      <TextField
        fullWidth
        label={fieldConfig.pricing.discountValue.label}
        placeholder={fieldConfig.pricing.discountValue.placeholder}
        name="pricing.discount.discountValue"
        type="number"
        value={values.pricing.discount?.discountValue ?? ""}
        onChange={handleChange}
        helperText={fieldConfig.pricing.discountValue.helperText}
      />

      <TextField
        fullWidth
        label={fieldConfig.pricing.minGroupSize.label}
        placeholder={fieldConfig.pricing.minGroupSize.placeholder}
        name="pricing.discount.minGroupSize"
        type="number"
        value={values.pricing.discount?.minGroupSize ?? ""}
        onChange={handleChange}
        helperText={fieldConfig.pricing.minGroupSize.helperText}
      />
    </Box>
  );
};

export default PricingSection;
